import * as TabsPrimitive from "@radix-ui/react-tabs";
import { ForwardedRef, forwardRef } from "react";

import { cn } from "../../lib/utils";

function Tabs({ children, className, ...props }: TabsPrimitive.TabsProps) {
  return (
    <TabsPrimitive.Root className={cn("flex flex-col", className)} {...props}>
      {children}
    </TabsPrimitive.Root>
  );
}

function TabsList({ children, className, ...props }: TabsPrimitive.TabsListProps, ref: ForwardedRef<HTMLDivElement>) {
  return (
    <TabsPrimitive.List ref={ref} className={cn("grid border-b border-gray-600", className)} {...props}>
      {children}
    </TabsPrimitive.List>
  );
}

function TabsTrigger({ children, className, ...props }: TabsPrimitive.TabsTriggerProps, ref: ForwardedRef<HTMLButtonElement>) {
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(
        "text-foreground border-b-2 border-transparent hover:text-primary",
        "data-[state=active]:border-primary data-[state=active]:font-semibold data-[state=active]:text-primary data-[state=active]:bg-gray-100",
        "disabled:cursor-not-allowed",
        className
      )}
      {...props}
    >
      {children}
    </TabsPrimitive.Trigger>
  );
}

function TabsContent({ children, className, ...props }: TabsPrimitive.TabsContentProps, ref: ForwardedRef<HTMLDivElement>) {
  return (
    <TabsPrimitive.Content ref={ref} className={cn("grid gap-3 data-[state=inactive]:hidden", className)} {...props}>
      {children}
    </TabsPrimitive.Content>
  );
}

Tabs.List = forwardRef(TabsList);
Tabs.Trigger = forwardRef(TabsTrigger);
Tabs.Content = forwardRef(TabsContent);
export default Tabs;
